import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const RECENT_BUYERS = [{
  name: 'María',
  location: 'Bogotá, Colombia'
}, {
  name: 'Ana',
  location: 'Lima, Perú'
}, {
  name: 'Valentina',
  location: 'Buenos Aires, Argentina'
}, {
  name: 'Sofía',
  location: 'Santiago, Chile'
}, {
  name: 'Camila',
  location: 'Ciudad de México, México'
}, {
  name: 'Isabella',
  location: 'Medellín, Colombia'
}, {
  name: 'Lucía',
  location: 'Montevideo, Uruguay'
}, {
  name: 'Gabriela',
  location: 'San José, Costa Rica'
}, {
  name: 'Elena',
  location: 'Quito, Ecuador'
}, {
  name: 'Carmen',
  location: 'Madrid, España'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [buyer, setBuyer] = useState(RECENT_BUYERS[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNewBuyer();
    }, 5000);
    // Loop
    const interval = setInterval(() => {
      showNewBuyer();
    }, 20000); // Every 20 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNewBuyer = () => {
    const randomBuyer = RECENT_BUYERS[Math.floor(Math.random() * RECENT_BUYERS.length)];
    setBuyer(randomBuyer);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 max-w-xs w-full animate-slide-up" data-id="element-267">
      <div className="bg-white rounded-lg shadow-lg border-l-4 border-green-500 p-4 flex items-start gap-3 relative" data-id="element-268">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-269">
          <X size={14} data-id="element-270" />
        </button>
        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-271">
          <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-272" />
        </div>
        <div data-id="element-273">
          <p className="text-sm font-semibold text-gray-800" data-id="element-274">¡Nueva compra!</p>
          <p className="text-sm text-gray-600" data-id="element-275">
            <span className="font-medium" data-id="element-276">{buyer.name}</span> de{' '}
            {buyer.location} acaba de comprar este libro.
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-277">Hace unos segundos</p>
        </div>
      </div>
    </div>;
}